export default {
  'feBasedError.title':
    "Hay aksi! <color>Examod</color>'da bir şeyler yanlış gitti.",
  'feBasedError.desc':
    'İsteğiniz işlenirken beklenmeyen bir hata oluştu. Sorunu en kısa sürede çözeceğiz.',
};
